/* Ishira product-card metal dots (THEME-010, 2026-10-10). Markup: snippets/product-grid-item-swatches.liquid.
   Hover/focus (pointer devices) previews a metal; click/tap selects it: the card image crossfades to that metal's
   variant image and the card links point to ?variant=. No navigation from the dots themselves. */
(function () {
  'use strict';
  try {
    var q = new URLSearchParams(window.location.search).get('cards');
    if (q === 'a' || q === 'b') sessionStorage.setItem('ishCards', q);
    var v = sessionStorage.getItem('ishCards');
    if (v) document.documentElement.setAttribute('data-ish-cards', v);
  } catch (e) { /* storage blocked: default variant */ }

  var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;

  function card(el) { return el.closest('.grid-product, .grid__item, [data-product-id]'); }
  function mainImg(c) {
    return c.querySelector('.grid-product__image-mask .grid__image-ratio img, .grid-product__image-mask img.image-element, .grid-product__image-mask img');
  }
  function layer(c) {
    var img = mainImg(c);
    if (!img) return null;
    var host = img.closest('.grid__image-ratio, .image-wrap, image-element') || img.parentNode;
    var l = host.querySelector('img.ish-mswap');
    if (!l) {
      l = document.createElement('img');
      l.className = 'ish-mswap';
      l.alt = '';
      l.decoding = 'async';
      var cs = window.getComputedStyle(img);
      l.style.objectFit = cs.objectFit || 'cover';
      l.style.objectPosition = cs.objectPosition;
      if (window.getComputedStyle(host).position === 'static') host.style.position = 'relative';
      l.sizes = img.getAttribute('sizes') || '(min-width: 769px) 25vw, 50vw';
      host.appendChild(l);
    }
    return l;
  }
  function show(btn) {
    var c = card(btn);
    if (!c) return;
    var l = layer(c);
    if (!l) return;
    if (btn.hasAttribute('data-default') || !btn.dataset.src) { l.classList.remove('is-on'); return; }
    if (l.dataset.src === btn.dataset.src) { l.classList.add('is-on'); return; }
    l.classList.remove('is-on');
    l.dataset.src = btn.dataset.src;
    l.onload = function () { if (l.dataset.src === btn.dataset.src) l.classList.add('is-on'); };
    if (btn.dataset.srcset) l.srcset = btn.dataset.srcset;
    l.src = btn.dataset.src;
    if (l.complete && l.naturalWidth) l.classList.add('is-on');
  }
  function active(group) { return group.querySelector('.ish-mdot[aria-pressed="true"]'); }
  function restore(group) {
    var a = active(group);
    if (a) { show(a); return; }
    var c = card(group), l = c && c.querySelector('img.ish-mswap');
    if (l) l.classList.remove('is-on');
  }
  function select(btn) {
    var group = btn.closest('[data-ish-mdots]');
    group.querySelectorAll('.ish-mdot').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
    show(btn);
    var c = card(btn);
    if (c && btn.dataset.url) {
      c.querySelectorAll('a[href*="/products/"]').forEach(function (a) { a.href = btn.dataset.url; });
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ish-mdots] .ish-mdot');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    select(btn);
  });
  if (canHover) {
    document.addEventListener('mouseover', function (e) {
      var btn = e.target.closest && e.target.closest('[data-ish-mdots] .ish-mdot');
      if (btn) show(btn);
    });
    document.addEventListener('mouseout', function (e) {
      var group = e.target.closest && e.target.closest('[data-ish-mdots]');
      if (group && !(e.relatedTarget && group.contains(e.relatedTarget))) restore(group);
    });
  }
  document.addEventListener('focusin', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ish-mdots] .ish-mdot');
    if (btn) show(btn);
  });
  document.addEventListener('focusout', function (e) {
    var group = e.target.closest && e.target.closest('[data-ish-mdots]');
    if (group && !(e.relatedTarget && group.contains(e.relatedTarget))) restore(group);
  });
})();
